module.exports = __webpack_public_path__ + "6042.87d5d594a179f35d101592a8ae7a99d6.cache.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/anim/6042.png
// module id = 493
// module chunks = 0